import styled from "styled-components";

export const Container = styled.div`
`;

export const CheckboxLabel = styled.div<{ checked: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
  padding: 10px;
  background: ${props => props.checked ? props.theme.colors.Primary05 : '#f9fafb'};
  border-radius: 8px;
  border: ${props => props.checked ? `2px solid ${props.theme.colors.Primary}` : '2px solid #e5e7eb'};
`;

export const CheckboxText = styled.label<{ checked: boolean }>`
  font-weight: 500;
  color: ${props => props.checked ? props.theme.colors.Primary : '#374151'};
  cursor: pointer;
`;

export const SummaryWrapper = styled.div`
  margin-top: 24px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 8px;
`;

export const SummaryText = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 18px;
  color: #6b7280;
font-size: 13px;

  * {
    display: inline;
  }

  strong {
  font-size: 13px;
    display: inline;
    font-weight: 500;
    color: #111827;
   
  }
`;
